import { connect } from "react-redux";
import { KiemKho } from "components/KiemKho";
import { getListKiemKho } from "actions/KiemKho";

const mapStateToProps = (state) => ({
  kiemkho: state.kiemkho,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListKiemKho: (dataSearch) => dispatch(getListKiemKho(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(KiemKho);
